import { IDesactivarRegistro } from "../entities/ILogMantenedor";
import { deleteAPI, postAPI } from "../helpers/httpHelper";
import {
  API_PROVIDER_POST_DESACTIVARMEDIDA,
  API_PROVIDER_POST_DESACTIVARPLANIFICACION,
  API_PROVIDER_POST_DESACTIVARPROGRAMAANUAL,
  API_PROVIDER_POST_ELIMINARMEDIDA,
  API_PROVIDER_POST_ELIMINARPLANIFICACION,
  API_PROVIDER_POST_ELIMINARPROGRAMAANUAL,
  API_PROVIDER_POST_GENERARPDFPLANIFICACION,
  URL_PROVIDER,
} from "../helpers/variableHelper";

export default class ProveedorService {
  public static async desactivarRegistroProgramaAnual(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${URL_PROVIDER}${API_PROVIDER_POST_DESACTIVARPROGRAMAANUAL}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async desactivarRegistroPlanificacion(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${URL_PROVIDER}${API_PROVIDER_POST_DESACTIVARPLANIFICACION}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }
  public static async desactivarRegistroMedida(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${URL_PROVIDER}${API_PROVIDER_POST_DESACTIVARMEDIDA}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarRegistroProgramaAnual(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${URL_PROVIDER}${API_PROVIDER_POST_ELIMINARPROGRAMAANUAL}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarRegistroPlanificaciones(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${URL_PROVIDER}${API_PROVIDER_POST_ELIMINARPLANIFICACION}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarRegistroMedida(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${URL_PROVIDER}${API_PROVIDER_POST_ELIMINARMEDIDA}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static GenerarPDFPlanificacion = async (token: string, idPlanificacion: number) => {
    postAPI(
      `${URL_PROVIDER}${API_PROVIDER_POST_GENERARPDFPLANIFICACION}`,
      {
        ID: idPlanificacion,
      },
      {
        Authorization: `Bearer ${token}`,
      }
    ).catch((e) => console.log(e));
  };
}
